import { GameVars } from './../../GameVars';
import { BoardContainer } from './BoardContainer';
import { BallsContainer } from "./BallsContainer";
import { BoardManager } from "./BoardManager";
import { GameConstants } from "../../GameConstants";

export class Ball extends Phaser.GameObjects.Image {

    public static BALL_RADIUS = 34.5;

    public id: number;

    public canMove: boolean;
    public moving: boolean;

    public ballsContainer: BallsContainer;
    public newContainer: BallsContainer;

    private downTime: number;

    constructor(scene: Phaser.Scene, id: number, ballsContainer: BallsContainer) {
        
        super(scene, 0, 0, "texture_atlas_1", "ball_" + id);

        this.id = id;
        this.canMove = false;
        this.moving = false;

        this.ballsContainer = ballsContainer;

        this.setInteractive();
        this.on("pointerdown", this.onDown, this);
        this.on("pointerup", this.onUp, this);

        this.scene.sys.updateList.add(this);
    }

    public preUpdate(): void {

        if (this.moving) {
            this.setPosition(this.scene.input.activePointer.x - GameConstants.GAME_WIDTH / 2, (this.scene.input.activePointer.y - GameConstants.GAME_HEIGHT / 2) / GameVars.scaleY);

            let containers = BoardContainer.currentInstance.ballsContainers;

            for (let i = 0; i < containers.length; i++) {

                if (Phaser.Geom.Rectangle.Overlaps(this.getBounds(), containers[i].img.getBounds())) {
                    this.moveToContainer(containers[i]);
                    this.newContainer = containers[i];
                    break;
                }

                this.newContainer = null;
            }

            if (!this.scene.input.activePointer.isDown) {
                this.onUp();
            }
        }

        if (this.canMove && this.scene.input.activePointer.isDown) {
            let x = this.scene.input.activePointer.x - GameConstants.GAME_WIDTH / 2;
            let y = this.scene.input.activePointer.y - GameConstants.GAME_HEIGHT / 2;

            let off = Ball.BALL_RADIUS;

            if (this.x > x - off && this.x < x + off && this.y > y - off && this.y < y + off) {
                this.moving = true;
            }
        }
    }

    public restitute(): void {

        this.canMove = false;
        
        let x = this.ballsContainer.x;
        let y = this.ballsContainer.y - Ball.BALL_RADIUS * this.scaleX * 2 * 1.05 * (this.ballsContainer.balls.length - 1);

        this.scene.tweens.add({
            targets: this,
            x: x,
            y: y,
            ease: Phaser.Math.Easing.Bounce.Out,
            duration: 200
        });
    }

    public extract(): void {

        this.downTime = Date.now();

        let x = this.ballsContainer.x;
        let y = this.ballsContainer.y - Ball.BALL_RADIUS * this.scaleX * 2 * 1.05 * 4.4;

        this.scene.tweens.add({
            targets: this,
            y: y,
            x: x,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 100,
            onComplete: () => {
                this.canMove = true;
            },
            onCompleteScope: this
        });
    }

    private onDown(): void {

        if (!this.canMove) {
            return;
        }

        this.downTime = Date.now();

        this.moving = true;
    }

    private onUp(): void {

        if (!this.canMove) {
            return;
        } 

        if (Date.now() - this.downTime < 200) {
            this.moving = false;
            return;
        }

        if (this.newContainer) {
            this.moving = false;
            BoardManager.onBallsContainerSelected(this.newContainer.id, true);
        } else {
            this.moving = false;
            this.extract();
        }
        
    }

    private moveToContainer(container: BallsContainer): void {

        this.x = container.x;
        this.y = container.y - Ball.BALL_RADIUS * this.scaleX * 2 * 1.05 * 4.4;

        // this.scene.tweens.add({
        //     targets: this,
        //     y: y,
        //     x: x,
        //     ease: Phaser.Math.Easing.Linear.Linear,
        //     duration: 100
        // });
    }
}
